
/**
 * @description this enum was created to resolve interference problem
 * we handle all forms submits of the application using isFormSubmitted
 * state which was just a boolean, using the enum, we are able to assign 
 * an array of booleans and map using the enums
 */
export enum form {
    CREATE_UPDATE_PATIENT_FORM = 'createUpdatePatientForm',
    PERSONAL_MEDICAL_HISTORY = 'personalMedicalHistory',
    SURGICAL_MEDICAL_HISTORY = 'surgicalMedicalHistory',
    FAMILY_MEDICAL_HISTORY = 'familyMedicalHistory',
    TOXIC_HABITS = 'toxicHabits',
    LIFETIME_OBSTETRIC_INFORMATIONS = 'lifetimeObstetricInformations',
    OBSTETRIC_HISTORY = 'obstetricHistory',
    ALLERGIES = 'allergies',
    SCREENING = 'screening'
}
